import i18next from 'i18next'
import React from 'react'
import { ParsedPhoneNumber } from '../../utils/phoneNumber'
import { DepartmentIcon, SpaarneCentrumType, SpaarneDepartmentType } from '../../utils/spaarneIcons'
import { locationExpandBlockClasses } from '../../utils/style'
import { getClassName } from '../../utils/utils'
import { useInView } from '../hooks/useInView'
import { GenericPageHeader } from '../sharedLayout/pageheader'

export type VerpleegafdelingenLayoutProps = {
  location?: string
  list: {
    clinic: {
      phoneNumber: Array<ParsedPhoneNumber & { description: string; title: string }>
      visitingTimes: string
      route: string
    }
    facility:
      | { kind: 'department'; title: SpaarneDepartmentType }
      | { kind: 'centrum'; title: SpaarneCentrumType }
  }[]
  breadcrumbs: { title: string; url: string }[]
}

export const VerpleegafdelingenLayout = (props: VerpleegafdelingenLayoutProps) => {
  const { inView, ref } = useInView(
    { threshold: 0.1 },
    (inview) => console.debug("VerpleegafdelingenLayout inView:", inview),
    true
  )
  return (
    <>
      <GenericPageHeader
        kind="verpleegafdelingenOverview"
        breadcrumbs={props.breadcrumbs}
        title={`${i18next.t('misc:verpleegAfdeling_plural')}${props.location ? ` - ${props.location}` : ''}`}
        intro={
          i18next.exists('misc:verpleegAfdelingOverviewIntro')
            ? i18next.t('misc:verpleegAfdelingOverviewIntro')
            : undefined
        }
      />
      <section
        key={`block-clinics`}
        id={`io-clinics`}
        ref={ref}
        className={getClassName(locationExpandBlockClasses, 'blockClassName', 'container') + ' ' + (inView ? getClassName(locationExpandBlockClasses, 'inviewClassName', 'inview') : '')}
      >
        <div className="block__inner container--m gutter--m">
          <ul className="block__list list--clickable list--teasers">
            {props.list
              .sort((a, b) => (a.facility.title < b.facility.title ? -1 : 1))
              .map((item) =>
                item.clinic ? (
                  <li className="list__item" key={item.facility.title}>
                    <div className="list__wrapper">
                      <article className="list__article">
                        <div className="list__visual list__visual--svg">
                          {item.facility.kind === 'centrum' ? (
                            <svg aria-hidden="true" width="50px" height="50px" className="list__icon">
                              <use xlinkHref="#icon--SG-informatie" />
                            </svg>
                          ) : (
                            <DepartmentIcon
                              className="list__icon"
                              width="50px"
                              height="50px"
                              department={item.facility.title}
                            />
                          )}
                        </div>

                        <div className="list__content">
                          <h2 className="list__title">{item.facility.title}</h2>
                          {(item.clinic.phoneNumber ?? []).map(x => {
                            if (x.formatted && x.uri) {

                              return (

                                <a
                                  key={x.formatted + x.uri}
                                  href={x.uri}
                                  title={i18next.t('common:callOn', {
                                    location: x.title || x.description,
                                  })}
                                  className={getClassName(locationExpandBlockClasses, 'locationPhoneClassName', '')}
                                >
                                  <span className="sr-text">{i18next.t('common:phoneNumber')}</span>
                                  {x.formatted}
                                </a>
                              )
                            }
                          }
                          )
                          }
                          {item.clinic.route && (
                            <p className={getClassName(locationExpandBlockClasses, 'locationDescriptionClassName', '')}>
                              {`${i18next.t('common:route')}: ${item.clinic.route}`}
                            </p>
                          )}
                          {i18next.exists('misc:visitingTimesLink') &&
                            <p className={getClassName(locationExpandBlockClasses, 'locationDescriptionClassName', '')}
                              dangerouslySetInnerHTML={{ __html: i18next.t('misc:visitingTimesLink') }}
                            />
                          }
                        </div>
                      </article>
                    </div>
                  </li>
                ) : (
                  <></>
                )
              )}
          </ul>
        </div>
      </section>
    </>
  )
}
